import styled from 'styled-components'

export const Container = styled.div`
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  overflow: hidden;

  .ql-toolbar.ql-snow {
    border: none;
    border-radius: ${props => props.theme.primitives.radius.radius0};
  }

  .ql-container.ql-snow {
    border: none;
    max-height: ${props => props.maxHeight};
    overflow-y: auto;
  }

  .ql-editor.ql-blank::before {
    left: ${props => props.theme.spacing.sp16};
  }
`
